import getApi from "./getApi";

const api = getApi("http");

export default api;
